import { render, staticRenderFns } from "./ActItem.vue?vue&type=template&id=01e56ec8&scoped=true"
import script from "./ActItem.vue?vue&type=script&lang=js"
export * from "./ActItem.vue?vue&type=script&lang=js"
import style0 from "./ActItem.vue?vue&type=style&index=0&id=01e56ec8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e56ec8",
  null
  
)

export default component.exports